import { DocumentPackageType } from './document-package';
import { JobType, PipelineName } from './pipeline';
import { PROCESSORS_BY_PACKAGE_TYPE } from './processor-name';
const COMMON_DOCUMENT_PIPELINES = [
    PipelineName.DEFAULT,
    PipelineName.VALIDATION_ONLY,
    PipelineName.PRE_PARSING_ONLY,
    PipelineName.PARSING_ONLY,
    PipelineName.POST_PARSING_ONLY,
    PipelineName.TEXT_PROCESSING_ONLY,
    PipelineName.POST_PROCESSING_ONLY,
];
const TEXT_PROCESSING_DOCUMENT_PIPELINES = [
    PipelineName.VALIDATION_TO_TEXT_PROCESSING,
    PipelineName.VALIDATION_ONLY,
    PipelineName.PRE_PARSING_ONLY,
    PipelineName.PARSING_ONLY,
    PipelineName.POST_PARSING_ONLY,
    PipelineName.TEXT_PROCESSING_ONLY,
];
const TENDER_DOCUMENTS_PIPELINES = [
    ...COMMON_DOCUMENT_PIPELINES,
    PipelineName.COMPARISON,
    PipelineName.TEXT_COMPARISON_ONLY,
    PipelineName.PACKAGE_COMPARISON,
    PipelineName.PACKAGE_COMPARISON_ONLY,
];
export const PIPELINES_BY_DOCUMENT_TYPE = {
    [DocumentPackageType.TENDER_DOCUMENTS]: TENDER_DOCUMENTS_PIPELINES,
    [DocumentPackageType.TENANT_REQUIREMENTS]: COMMON_DOCUMENT_PIPELINES,
    [DocumentPackageType.OFFER]: [
        ...COMMON_DOCUMENT_PIPELINES,
        PipelineName.BID_REVIEW,
        PipelineName.BID_REVIEW_MIRRORING_ONLY,
        PipelineName.METADATA_EXTRACTION_ONLY,
        PipelineName.BID_REVIEW_TEXT_PROCESSING_ONLY,
    ],
    [DocumentPackageType.TENANT_SPECIFICATION]: COMMON_DOCUMENT_PIPELINES,
    [DocumentPackageType.MANAGEMENT_OPERATIONS_MAINTENANCE]: COMMON_DOCUMENT_PIPELINES,
    [DocumentPackageType.CONTRACT_REVIEW]: COMMON_DOCUMENT_PIPELINES,
    [DocumentPackageType.DUE_DILIGENCE]: COMMON_DOCUMENT_PIPELINES,
    [DocumentPackageType.DESIGN_PACKAGE_REVIEW]: TEXT_PROCESSING_DOCUMENT_PIPELINES,
    [DocumentPackageType.RFP_RFQ_REVIEW]: COMMON_DOCUMENT_PIPELINES,
    [DocumentPackageType.LUMINAIRE_SCHEDULE]: [PipelineName.LUMINAIRE_SCHEDULE],
    [DocumentPackageType.SITE_DUE_DILIGENCE]: [
        PipelineName.DOCUMENT_PACKAGE_REPORTS,
        PipelineName.DOCUMENT_PACKAGE_REPORTS_ONLY,
        PipelineName.VALIDATION_ONLY,
        PipelineName.PRE_PARSING_ONLY,
    ],
    [DocumentPackageType.REPORT_GENERATION]: [
        PipelineName.REPORT_GENERATION_PRECHECK,
        PipelineName.REPORT_TEMPLATE_CREATION,
        PipelineName.REPORT_GENERATION,
        PipelineName.REPORT_GENERATION_ONLY,
        PipelineName.VALIDATION_ONLY,
        PipelineName.PRE_PARSING_ONLY,
        PipelineName.PARSING_ONLY,
        PipelineName.POST_PARSING_ONLY,
    ],
    [DocumentPackageType.SCHEDULE_CHECK]: [
        PipelineName.SCHEDULE_CHECK,
        PipelineName.SCHEDULE_CHECK_ONLY,
        PipelineName.VALIDATION_ONLY,
        PipelineName.PRE_PARSING_ONLY,
        PipelineName.PARSING_ONLY,
    ],
    [DocumentPackageType.VERSION_COMPARE]: [PipelineName.VERSION_COMPARE],
    [DocumentPackageType.WATER_PROCESS_SYSTEMS_AGENT]: TEXT_PROCESSING_DOCUMENT_PIPELINES,
};
export const PIPELINES_BY_JOB_TYPE = {
    [JobType.BUILDING_PACKAGE]: [
        PipelineName.IFC_EXTRACTION_ONLY,
        PipelineName.IFC_EXPORT,
        PipelineName.LOAD_CALCULATION,
        PipelineName.CEILING_GRID_OPTIMIZATION_ONLY,
        PipelineName.DUCT_ROUTING_ONLY,
        PipelineName.APARTMENT_ROUTING_ONLY,
        PipelineName.CORRIDOR_ROUTING_ONLY,
        PipelineName.ESCAPE_ROUTE,
        PipelineName.REVIT_GENERATOR,
        PipelineName.VALIDATION_ONLY,
        PipelineName.PRE_PARSING_ONLY,
        PipelineName.PARSING_ONLY,
        PipelineName.POST_PARSING_ONLY,
    ],
    [JobType.LAYOUT_OPTIMIZATION]: [
        PipelineName.SPACE_ANALYSIS,
        PipelineName.PARKING,
        PipelineName.PLANT_ROOM,
    ],
};
export const getPipelinesForPackage = (jobType, documentPackageType) => {
    if (jobType !== JobType.DOCUMENT_PACKAGE) {
        return PIPELINES_BY_JOB_TYPE[jobType] ?? [];
    }
    if (documentPackageType) {
        return PIPELINES_BY_DOCUMENT_TYPE[documentPackageType];
    }
    return [];
};
export const canSelectTextProcessor = (jobType, documentPackageType) => jobType === JobType.DOCUMENT_PACKAGE &&
    !!documentPackageType &&
    !!PROCESSORS_BY_PACKAGE_TYPE[documentPackageType]?.length;
